var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNineToTwelvePmBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7279 7H24.1553C23.9853 6.2755 23.634 5.61799 23.1413 5.1022C22.6487 4.5864 22.0344 4.233 21.3683 4.08214C20.7022 3.93128 20.011 3.98902 19.3733 4.2488C18.7355 4.50857 18.1768 4.95997 17.7605 5.55169C17.3443 6.14341 17.0872 6.85174 17.0186 7.59618C16.9499 8.34061 17.0724 9.09132 17.3721 9.76298C17.6719 10.4346 18.1368 11.0003 18.7141 11.3958C19.2915 11.7912 19.958 12.0006 20.6381 12H24.7279C25.3305 12 25.9084 11.7366 26.3345 11.2678C26.7606 10.7989 27 10.163 27 9.5C27 8.83696 26.7606 8.20107 26.3345 7.73223C25.9084 7.26339 25.3305 7 24.7279 7Z",
    stroke: "#4D55E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 18.8108C18.8424 20.5166 18.2022 22.1423 17.1543 23.4975C16.1065 24.8528 14.6944 25.8816 13.0832 26.4636C11.4719 27.0456 9.72832 27.1566 8.05629 26.7838C6.38426 26.411 4.85298 25.5697 3.64164 24.3584C2.43031 23.147 1.589 21.6157 1.21618 19.9437C0.843359 18.2717 0.954435 16.5281 1.53641 14.9168C2.11839 13.3056 3.1472 11.8935 4.50246 10.8457C5.85772 9.79783 7.48337 9.15764 9.18919 9C8.19048 10.3511 7.7099 12.0158 7.83485 13.6914C7.95979 15.3669 8.68197 16.9419 9.87003 18.13C11.0581 19.318 12.6331 20.0402 14.3086 20.1652C15.9842 20.2901 17.6489 19.8095 19 18.8108Z",
    stroke: "#4D55E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNineToTwelvePmBlue);
export default __webpack_public_path__ + "static/media/nineToTwelvePm-blue.f27a079ab6bee3cd79c9cb7f4af7d134.svg";
export { ForwardRef as ReactComponent };